// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@vanmeter/App/SharedStyles/CartLineSharedStyles";
import { requestRmaProductListStyles } from "@vanmeter/Overrides/Widgets/RequestRma/RequestRmaProductList";
import { mergeWithCss, priceRequireQuoteMessage, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

requestRmaProductListStyles.productTotalPriceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

requestRmaProductListStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

requestRmaProductListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

requestRmaProductListStyles.returnReasonSelect = {
    mergeCss: true,
    cssOverrides: {
        formField: css`
            width: auto;
            margin-top: 10px;
        `,
        formInputWrapper: css`
            max-width: 225px;
            width: 225px;
            ${xScreen("lte", "xs")} {
                width: auto;
            }
        `,
    },
};

requestRmaProductListStyles.qtyToReturnTextField = {
    cssOverrides: {
        formField: css`
            width: 100px;
            margin-right: auto;
            ${xScreen("lte", "xs")} {
                margin-right: 0;
            }
        `,
        formInputWrapper: css`
            width: 90px;
        `,
    },
};

requestRmaProductListStyles.gridContainer = {
    css: css`
        margin-bottom: 24px;
    `,
};

requestRmaProductListStyles.cartLineContainerStyles = {
    actions: {
        css: css`
            grid-column: 3 / 7;
            justify-content: end;
            ${xScreen("lte", "md")} {
                justify-content: start;
            }
        `,
    },
    notes: {
        css: css`
            flex-direction: column;
        `,
    },
};

requestRmaProductListStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

requestRmaProductListStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
        css: css`
            display: inline-flex;
            width: auto;
        `,
    }),
};

requestRmaProductListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            margin-left: 4px;
        `,
    }),
};

requestRmaProductListStyles.orderLineCardImage = {
    height: "96px",
    width: "96px",
    css: css`
        img {
            height: auto;
            max-width: 100%;
            max-height: 100%;
        }
    `,
};

requestRmaProductListStyles.notifyMsg = {
    css: css`
        max-width: unset;
    `,
};

requestRmaProductListStyles.quoteText = {
    ...priceRequireQuoteMessage
};
